export default __webpack_public_path__ + "static/media/585.197c4886.png";